import React from "react";

export default function PageHero({ title, subtitle, img }) {
  return (
    <section className="pageHero">
      <div
        className="pageHero__bg"
        style={{
          backgroundImage: `linear-gradient(to right, rgba(0,0,0,.25), rgba(0,0,0,.6)), url(${img})`,
        }}
      />
      <div className="container pageHero__inner">
        <div className="pageHero__text">
          <h1 className="pageHero__title">{title.toUpperCase()}</h1>
          <p className="pageHero__subtitle">{subtitle}</p>
        </div>
      </div>
    </section>
  );
}
